import { MemberBenefitFlyout } from "./enrollment-option";
import { WidgetError } from "./widget";

export class EnrollmentBenefitCategory {
    benefitCategories: EnrollmentBenefitCategoryItem[];
    isCheckoutEnabled: boolean;
    widgetErrorModel: WidgetError;
    memberBenefitFlyout: MemberBenefitFlyout;
    
    constructor() {
        this.benefitCategories = new Array<EnrollmentBenefitCategoryItem>();
        this.isCheckoutEnabled = false;
        this.widgetErrorModel = new WidgetError();
        this.memberBenefitFlyout = new MemberBenefitFlyout();
    }
}

export class EnrollmentBenefitCategoryItem {
    enrollmentHTML: string;
    id: number
    name: string;
    isRequired: boolean;
    isCompleted: boolean;
    isWaived: boolean;
    materialIconName: string;
    isDisabled: boolean;

    constructor() {
        this.materialIconName = null;
        this.id = 0;
        this.name = null;
        this.isCompleted = false;
        this.isRequired = false;
        this.isWaived = false;
        this.materialIconName = null;
        this.isDisabled = false;
    }
}

export class EnrollmentWaiveBenefits {
    benefitNumber: number;

    constructor() {
        this.benefitNumber = 0;
    }
}

export class EnrollmentBenefitTerm {
    benefitNumber: number;

    constructor() {
        this.benefitNumber = 0;
    }
}